import { ProductType } from "@/app/(marketing)/pricing/types";
import { getGrantedEntitlementsFromSubscriptions, type ProductKey, type SubscriptionLike } from "@/lib/billing/entitlements";
import { findMinimumBundleForEntitlements, type BundleTierId } from "@/lib/billing/bundle-entitlements";

export const PRODUCT_TYPE_TO_PRODUCT_KEY_MAP: Record<ProductType, ProductKey> = {
  [ProductType.EV_OPTIMIZER]: "ev-plan",
  [ProductType.WHALE_WATCH]: "whale-watch",
  [ProductType.EV_SNIPER]: "ev-sniper",
};

const evOptimizerSubscriptionRequired = [
  "/optimizer",
  "/low-hold",
  "/arbitrage",
  "/prop-discrepancies",
  "/ev-sniper",
  "/edge-finder",
];
const whaleWatchSubscriptionRequired = ["/whale-watch"];
const evSniperSubscriptionRequired = ["/ev-sniper", "/edge-finder"];

export function getRequiredProductType(pathname: string): ProductType | null {
  if (evSniperSubscriptionRequired.some((route) => pathname.startsWith(route))) {
    return ProductType.EV_SNIPER;
  }
  if (evOptimizerSubscriptionRequired.some((route) => pathname.startsWith(route))) {
    return ProductType.EV_OPTIMIZER;
  }
  if (whaleWatchSubscriptionRequired.some((route) => pathname.startsWith(route))) {
    return ProductType.WHALE_WATCH;
  }
  return null;
}

type MemberPlanRow = SubscriptionLike & { period_end?: string | null };

export function lockedToolTier(
  pathname: string,
  subscriptions: readonly MemberPlanRow[],
  now: Date = new Date(),
): BundleTierId | null {
  const productType = getRequiredProductType(pathname);
  if (!productType) return null;
  const product = PRODUCT_TYPE_TO_PRODUCT_KEY_MAP[productType];
  const live = subscriptions.filter(
    (sub) => !sub.period_end || new Date(sub.period_end).getTime() > now.getTime(),
  );
  if (getGrantedEntitlementsFromSubscriptions([...live], now).has(product)) return null;
  return findMinimumBundleForEntitlements(new Set([product]));
}
